// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__QE3L3","spinner":"Spinner_spinner__FXBDV","spin":"Spinner_spin__90Kdw"};